import axios from 'axios'

const path = 'server'

async function readFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsBinaryString(file)
    reader.onload = event => { resolve(btoa(event.target.result)) }
    reader.onerror = event => { reject(new Error("Couldn't read file")) }
  })
}

export default {
  async getPing() {
    const resp = await axios.get(`${path}/ping`)
    return resp.data
  },

  async getCurrentTime() {
    const resp = await axios.get(`${path}/currentTime`)
    return resp.data
  },

  async getVersionInfo() {
    const resp = await axios.get(`${path}/version`)
    return resp.data
  },

  async getMetrics() {
    const resp = await axios.get(`${path}/metrics`)
    return resp.data
  },

  async uploadSslPkcs12(fileInput, password) {
    const file = await readFile(fileInput)
    return axios.put(`${path}/sslPkcs12`, {
      file,
      password
    })
  },

  async getLogFileList() {
    const resp = await axios.get(`${path}/logFileList`)
    return resp.data
  },

  async getLogFile(name) {
    const resp = await axios.get(`${path}/logFile/${name}`, {
      responseType: 'blob',
      timeout: 30000
    })
    return resp.data
  }
}
